import { Reservation } from '@luxuryescapes/contract-svc-reservation';

export function getDisplayName(entity: unknown): string | undefined {
  if (!entity || typeof entity !== 'object') {
    return undefined;
  }
  const record = entity as Record<string, unknown>;
  const displayName = record.name ?? record.account_name ?? record.property_name ?? record.title;
  return typeof displayName === 'string' && displayName.trim() ? displayName : undefined;
}

export function getTargetIdValue(targetIds: Record<string, unknown> | null | undefined, key: string) {
  const value = targetIds?.[key];
  return typeof value === 'string' ? value : '';
}

export function getRoomMetadata(
  property: Reservation.Property | undefined,
  targetIds?: Record<string, unknown> | null,
) {
  if (!property || !targetIds) {
    return {};
  }
  const roomTypes = property.room_types ?? [];
  const roomTypeId = getTargetIdValue(targetIds, 'room_type_id');
  const roomRateId = getTargetIdValue(targetIds, 'room_rate_id');
  const ratePlanId = getTargetIdValue(targetIds, 'rate_plan_id');

  for (const roomType of roomTypes) {
    const roomRates = roomType.room_rates ?? [];
    const matchedRoomRate = roomRates.find(
      (roomRate) => String(roomRate.id) === String(roomRateId) || String(roomRate.rate_plan?.id) === String(ratePlanId),
    );

    if (String(roomType.id) === String(roomTypeId) || matchedRoomRate) {
      return {
        roomName: typeof roomType.name === 'string' ? roomType.name : undefined,
        ratePlanName: typeof matchedRoomRate?.rate_plan?.name === 'string' ? matchedRoomRate.rate_plan.name : undefined,
      };
    }
  }

  return {};
}

export function getUserDisplay(user: App.UserSummary | undefined) {
  return {
    email: user?.email || undefined,
    name: user?.full_name || undefined,
  };
}

export const EMPTY_USER_DISPLAY = getUserDisplay(undefined);
